import { decimalMul } from '@/utils/getCalculatedValue'
import { resetAttribute, sortArray } from '@/utils/handleData.js'
export default {
  namespaced: true,
  actions: {
    /********************************************** 动态获取固定字典表 ********************************************************/

    // 获取工程分类
    async getProjectType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'projectType',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/projecttype',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取建设性质
    async getBuildNature({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'buildNature',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/buildNature',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取资金来源
    async getSourceFunds({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'sourceFunds',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/fundingsource',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取工程用途
    async getEngineeringUse({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'engineeringUse',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/engineerpurpose',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取单位性质
    async getUnitNature({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'unitNature',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/natureunit',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取企业资质证书类型
    async getCertificateType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'certificateType',
          label: 'name',
          value: 'num',
          childrenKey: 'grades',
          url: '/organize/dictionary/companyCertificateType',
          data: {
            fields:
              'certificateTypeName,certificateGradeName,certificateTypeNum,certificateGradeNum'
          },
          customValue: true,
          connector: '/'
        },
        { root: true }
      )
    },
    // 获取项目活动类型
    async getOrgGroup({ dispatch, commit, rootState }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'orgGroup',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/projectactivity',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
      const list = rootState.dictionarys.orgGroup || []
      commit(
        'dictionarySet',
        {
          key: 'orgGroup',
          value: list.map((item) =>
            Object.assign({}, item, {
              label: item.label || item.activityType || item.type || '',
              value: item.value || item.activityUid || item.uid || ''
            })
          )
        },
        { root: true }
      )
    },
    // 获取项目状态
    async getBuildStatus({ dispatch, commit, rootState }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'buildStatus',
          label: 'type',
          value: 'uid',
          url: '/organize/dictionary/projectstatus',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
      const list = rootState.dictionarys.buildStatus || []
      commit(
        'dictionarySet',
        {
          key: 'buildStatus',
          value: list.map((item) =>
            Object.assign({}, item, {
              label: item.label || item.type || '',
              value: item.value || item.uid || ''
            })
          )
        },
        { root: true }
      )
    },
    // 获取全国省级名称
    async getProvince({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'province',
          label: 'province',
          value: 'code',
          url: '/rule/area/province'
        },
        { root: true }
      )
    },
    // 获取对应省份市县区（籍贯）
    async getNativePlace({ dispatch }, province) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'nativePlace',
          label: 'provinceCityCounty',
          value: 'code',
          url: '/rule/area/info',
          data: {
            fields: 'uid,gradeNum,gradeType,academicNum,academicType',
            province: province
          },
          sync: true
        },
        { root: true }
      )
    },
    // 获取当前职称
    async getAcademic({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'academic',
          label: 'academicType',
          value: 'uid',
          url: '/person/dictionary/academictitle',
          data: { fields: 'uid,gradeNum,gradeType,academicNum,academicType' }
        },
        { root: true }
      )
    },
    // 获取年龄段
    async getAgeGroup({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'ageGroup',
          label: 'groupName',
          value: 'ageUid',
          url: '/query/person/agegroup',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取政治面貌
    async getPolitical({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'political',
          label: 'type',
          value: 'uid',
          url: '/person/dictionary/politicaloutlook',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取文化程度
    async getEducationDegree({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'educationDegree',
          label: 'type',
          value: 'uid',
          url: '/person/dictionary/edudegree',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取资格证书类型
    async getQualificationType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'qualificationType',
          label: 'certificateType',
          value: 'certificateNum',
          url: '/person/dictionary/certificatemajor',
          data: { fields: 'certificateType,certificateNum' }
        },
        { root: true }
      )
    },
    // 获取资格证书专业分类
    async getProClassification({ dispatch }, certificateType) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'proClassification',
          label: 'name',
          value: 'code',
          childrenKey: 'list',
          url: '/person/dictionary/certificatetype',
          data: {
            fields: 'certificateType,certificateNum,dataGroup,dataNum',
            certificateNum: certificateType
          },
          sync: true,
          customlabel: 'left'
        },
        { root: true }
      )
    },
    // 获取资格证书类别工种
    async getWorkType({ dispatch }, certificateType) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'workType',
          label: 'name',
          value: 'code',
          childrenKey: 'list',
          url: '/person/dictionary/credentialscategory',
          data: {
            fields: 'credentialsNum,credentialsType,dataGroup,dataNum',
            gradeNum: certificateType
          },
          sync: true,
          customlabel: 'left'
        },
        { root: true }
      )
    },
    // 获取资格证书证书等级
    async getCertificateLevel({ dispatch }, certificateType) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'certificateLevel',
          label: 'name',
          value: 'code',
          childrenKey: 'list',
          url: '/person/dictionary/credentialsgrade',
          data: {
            fields: 'gradeNum,gradeType,dataGroup,dataNum',
            credentialsNum: certificateType
          },
          sync: true,
          customlabel: 'left'
        },
        { root: true }
      )
    },
    // 获取退场原因
    async getWalkoffCause({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'walkoffCause',
          label: 'noteInfo',
          value: 'enumType',
          url: '/query/buildtype/laborexitreason'
        },
        { root: true }
      )
    },
    // 获取管理单位参建类型
    async getBuildtype({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'buildType',
          label: 'buildType',
          value: 'buildUid',
          url: '/query/buildtype/typeinfo',
          data: { isAdmin: 1 }
        },
        { root: true }
      )
    },
    // 获取管理人员聘用方式
    async getEmployMethod({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'employMethod',
          label: 'noteInfo',
          value: 'enumType',
          url: '/query/person/employmentmethod'
        },
        { root: true }
      )
    },
    // 获取工人住宿类型
    async getLiveType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'liveType',
          label: 'noteInfo',
          value: 'enumType',
          url: '/query/person/staytype'
        },
        { root: true }
      )
    },
    // 获取通知公告类型
    async getMessageType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'messageType',
          label: 'messageName',
          value: 'uid',
          url: '/query/message/type'
        },
        { root: true }
      )
    },
    // 获取结算方式
    async getSettlementType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'settlementType',
          label: 'noteInfo',
          value: 'enumType',
          url: '/query/contract/setmethod',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取合同期限类型
    async getTermType({ dispatch }) {
      await dispatch(
        'dictionaryRequest',
        {
          key: 'termType',
          label: 'noteInfo',
          value: 'enumType',
          url: '/query/contract/basetimetype',
          data: { fields: 'uid,type,num' }
        },
        { root: true }
      )
    },
    // 获取形象进度分项类型
    async getProgressItemType({ rootState, rootGetters, commit, dispatch }) {
      if (!rootState.dictionarys.progressItemType) {
        const res = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/dictionary/progressitem',
            data: { projectType: rootGetters['user/projectType'] }
          },
          { root: true }
        )
        var progressItemType = res.data ? resetType(res.data) : []
        progressItemType = sortArray(progressItemType, ['progressItemCode'])
        commit(
          'dictionarySet',
          { key: 'progressItemType', value: progressItemType },
          { root: true }
        )
      }
      function resetType(data) {
        data.forEach((item) => {
          item.value = item.uid
          item.label =
            item.progressItemCode +
            '\xa0\xa0' +
            item.progressItemType +
            '\xa0\xa0' +
            (!item.children || !item.children.length
              ? 0 + '\xa0' + item.progressUnit
              : '')
          if (item.children && item.children.length) {
            item.children = resetType(item.children)
          } else {
            delete item.children
          }
        })
        return data
      }
    },

    /********************************************** 动态获取可自定义修改字典表 ********************************************************/

    /* *************工种字典表************* */

    // 添加工种数据
    async addBusiness({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/dictionary/businessinfo',
          data: data,
          msg: '添加工种数据成功'
        },
        { root: true }
      )
      return res
    },

    // 删除工种数据
    async deleteBusiness({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/dictionary/businessinfo',
          data: { uid: uid },
          msg: '删除工种数据成功'
        },
        { root: true }
      )
      return res
    },

    // 获取工种字典表
    async getBusiness({ rootState, dispatch }, params) {
      var sync = params
      if (rootState.currentStep.step === 'businessList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'business',
          label: 'type',
          value: 'uid',
          url: '/person/dictionary/businessinfo',
          data: { fields: 'uid,type,num,isSpecial' },
          sync: sync
        },
        { root: true }
      )
    },

    // 编辑工种数据
    async editBusiness({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/dictionary/businessinfo',
          data: data,
          msg: '编辑工种数据成功'
        },
        { root: true }
      )
      return res
    },

    /* **************重大病史************** */

    // 添加重大病史
    async addDisease({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/dictionary/diseaseinfo',
          data: data,
          msg: '添加重大病史成功'
        },
        { root: true }
      )
      return res
    },

    // 删除重大病史
    async deleteDisease({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/dictionary/diseaseinfo',
          data: { uid: uid },
          msg: '删除重大病史成功'
        },
        { root: true }
      )
      return res
    },

    // 获取重大病史字典表
    async getDisease({ rootState, dispatch }, params) {
      var sync = params
      if (rootState.currentStep.step === 'diseaseList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'isDisease',
          label: 'type',
          value: 'uid',
          url: '/person/dictionary/diseaseinfo',
          data: { fields: 'uid,type,num' },
          sync: sync
        },
        { root: true }
      )
    },

    // 编辑重大病史
    async editDisease({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/dictionary/diseaseinfo',
          data: data,
          msg: '编辑重大病史成功'
        },
        { root: true }
      )
      return res
    },

    /* **************科室部门************** */

    // 添加科室部门
    async addDepartment({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/dictionary/department',
          data: data,
          msg: '添加职能部门成功'
        },
        { root: true }
      )
      return res
    },
    // 删除科室部门
    async deleteDepartment({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/dictionary/department',
          data: { uid: uid },
          msg: '删除职能部门成功'
        },
        { root: true }
      )
      return res
    },
    // 获取科室部门字典表
    async getDepartment({ rootState, dispatch }, params) {
      var sync = params
      if (rootState.currentStep.step === 'departmentList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'department',
          label: 'type',
          value: 'uid',
          url: '/person/dictionary/department',
          data: { fields: 'uid,code,name,type,mark' },
          sync: sync
        },
        { root: true }
      )
    },
    // 编辑科室部门
    async editDepartment({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/dictionary/department',
          data: data,
          msg: '编辑职能部门成功'
        },
        { root: true }
      )
      return res
    },

    /* **************岗位职务************** */

    // 添加岗位职务
    async addJobTitle({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/dictionary/duties',
          data: data,
          msg: '添加岗位职务成功'
        },
        { root: true }
      )
      return res
    },

    // 删除岗位职务
    async deleteJobTitle({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/dictionary/duties',
          data: { uid: uid },
          msg: '删除岗位职务成功'
        },
        { root: true }
      )
      return res
    },

    // 获取岗位职务字典表
    async getJobTitle({ rootState, dispatch }, params) {
      var sync = params
      if (rootState.currentStep.step === 'jobTitleList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'jobTitle',
          label: 'type',
          value: 'uid',
          url: '/person/dictionary/duties',
          data: { fields: 'uid,code,name,type' },
          sync: sync
        },
        { root: true }
      )
    },

    // 编辑岗位职务
    async editJobTitle({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/dictionary/duties',
          data: data,
          msg: '编辑岗位职务成功'
        },
        { root: true }
      )
      return res
    },

    /* **************物资类型************** */

    // 添加物资类型
    async addGoodsType({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/dictionary/dgoodstype',
          data: Object.assign({}, data, orgUid ? { orgUid: orgUid } : {}),
          msg: '添加物资类型成功'
        },
        { root: true }
      )
      return res
    },

    // 删除物资类型
    async deleteGoodsType({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/dictionary/dgoodstype',
          data: { uid: uid },
          msg: '删除物资类型成功'
        },
        { root: true }
      )
      return res
    },

    // 获取物资类型
    async getGoodsType({ rootState, dispatch }, params) {
      const orgUid = await dispatch('eduOrgUid')
      var sync = params
      if (rootState.currentStep.step === 'goodsTypeList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'goodsType',
          label: 'goodsName',
          value: 'uid',
          childrenKey: 'goodsDetails',
          url: '/organize/dictionary/dgoodstype',
          data: orgUid ? { orgUid: orgUid } : {},
          sync: sync
        },
        { root: true }
      )
    },

    // 编辑物资类型
    async editGoodsType({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/dictionary/dgoodstype',
          data: Object.assign({}, data, orgUid ? { orgUid: orgUid } : {}),
          msg: '编辑物资类型成功'
        },
        { root: true }
      )
      return res
    },

    async syncGoodsType({ dispatch }, mode) {
      const orgUid = await dispatch('eduOrgUid')
      if (!orgUid) return { code: 500, msg: '系统默认字段不需要同步' }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/organize/dictionary/dgoodstype/sync?orgUid=' +
            encodeURIComponent(orgUid) +
            '&mode=' +
            encodeURIComponent(mode || 'fill'),
          data: {},
          msg: true
        },
        { root: true }
      )
      return res
    },

    /* **************物资单位************** */

    // 添加物资单位
    async addUnit({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/dictionary/unit',
          data: data,
          msg: '添加单位成功'
        },
        { root: true }
      )
      return res
    },

    // 删除物资单位
    async deleteUnit({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/dictionary/unit',
          data: { uid: uid },
          msg: '删除单位成功'
        },
        { root: true }
      )
      return res
    },

    // 获取物资单位
    async getUnit({ rootState, dispatch }, params) {
      var sync = params
      if (rootState.currentStep.step === 'unitList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'unit',
          label: 'unitName',
          value: 'uid',
          url: '/organize/dictionary/unit',
          sync: sync
        },
        { root: true }
      )
    },

    // 编辑物资单位
    async editUnit({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/dictionary/unit',
          data: data,
          msg: '编辑单位成功'
        },
        { root: true }
      )
      return res
    },

    /* **************生成试卷模版************** */

    // 添加生成试卷模版
    async addCreatePaperModel({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/template/paper',
          data: Object.assign({}, data, orgUid ? { orgUid: orgUid } : {}),
          msg: '添加生成试卷模版成功'
        },
        { root: true }
      )
      return res
    },

    // 删除生成试卷模版
    async deleteCreatePaperModel({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/template/paper',
          data: { uid: uid },
          msg: '删除生成试卷模版成功'
        },
        { root: true }
      )
      return res
    },

    // 获取试卷模版（一模板一条 + questionRules 多题型）
    async getCreatePaperModel({ commit, dispatch }) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/template/paperlist',
          data: orgUid ? { orgUid: orgUid } : {}
        },
        { root: true }
      )
      const rows = res.data ? sortArray(res.data, ['templateName']) : []
      const createPaperRules = []
      const createPaperModel = rows.map((raw) => {
        const item = JSON.parse(JSON.stringify(raw))
        let rules = Array.isArray(item.questionRules) ? item.questionRules : []
        // 兼容未迁移的旧「一题型一行」数据
        if ((!rules || !rules.length) && item.questionType) {
          rules = [
            {
              questionType: item.questionType,
              questionNum: item.questionNum,
              score: item.score
            }
          ]
        }
        let questionNum = 0
        let totolScore = 0
        const summaryParts = []
        rules.forEach((rule) => {
          const num = Number(rule.questionNum) || 0
          const score = Number(rule.score) || 0
          const lineScore = decimalMul(num, score)
          questionNum += num
          totolScore += Number(lineScore) || 0
          summaryParts.push(
            (rule.questionType || '') + num + '道×' + score + '分'
          )
          createPaperRules.push({
            uid: item.uid + '__' + (rule.questionType || ''),
            templateUid: item.uid,
            templateName: item.templateName,
            questionType: rule.questionType,
            questionNum: rule.questionNum,
            score: rule.score,
            totolScore: lineScore
          })
        })
        item.questionRules = rules
        item.questionNum = questionNum
        item.totolScore = totolScore
        item.rulesSummary = summaryParts.join('；')
        item.templateUid = item.templateUid || item.uid
        item.label =
          (item.templateName || '') +
          '\xa0\xa0\xa0\xa0共' +
          questionNum +
          '道题\xa0\xa0\xa0\xa0合计' +
          totolScore +
          '分'
        item.value = item.uid
        return item
      })
      commit(
        'dictionarySet',
        { key: 'createPaperRules', value: createPaperRules },
        { root: true }
      )
      commit(
        'dictionarySet',
        {
          key: 'createPaperModel',
          value: resetAttribute(
            JSON.parse(JSON.stringify(createPaperModel)),
            'label',
            'uid'
          )
        },
        { root: true }
      )
      // 列表展示用完整模板数据（含 questionRules）
      commit(
        'dictionarySet',
        { key: 'createPaperTemplates', value: createPaperModel },
        { root: true }
      )
    },

    // 编辑试卷模版
    async editCreatePaperModel({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/template/paper',
          data: Object.assign({}, data, orgUid ? { orgUid: orgUid } : {}),
          msg: '编辑生成试卷模版成功'
        },
        { root: true }
      )
      return res
    },

    async syncPaperModel({ dispatch }, mode) {
      const orgUid = await dispatch('eduOrgUid')
      if (!orgUid) return { code: 500, msg: '系统默认字段不需要同步' }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/organize/template/paper/sync?orgUid=' +
            encodeURIComponent(orgUid) +
            '&mode=' +
            encodeURIComponent(mode || 'fill'),
          data: {},
          msg: true
        },
        { root: true }
      )
      return res
    },

    /* **************班前教育内容************** */

    eduOrgUid({ rootState, rootGetters }) {
      return rootGetters['user/orgName'] === '甘肃大鹏鸟科技有限公司'
        ? ''
        : rootState.user.orgValue
    },

    async addEduContent({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/dictionary/edubrief',
          data: Object.assign({}, data, orgUid ? { orgUid } : { orgUid: data && data.orgUid }),
          msg: '添加教育内容成功'
        },
        { root: true }
      )
      return res
    },

    async deleteEduContent({ dispatch }, uid) {
      const orgUid = await dispatch('eduOrgUid')
      const silent = uid && typeof uid === 'object'
      const realUid = silent ? uid.uid : uid
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/dictionary/edubrief',
          data: orgUid
            ? { uid: realUid, orgUid: orgUid }
            : { uid: realUid },
          msg: silent ? false : '删除教育内容成功',
          noErrorMsg: !!silent
        },
        { root: true }
      )
      return res
    },

    async batchDeleteEduContent({ dispatch, commit }, uids) {
      const list = Array.isArray(uids) ? uids.filter(Boolean) : []
      if (!list.length) {
        return { code: 400, msg: '请先选择要删除的教育内容' }
      }
      let ok = 0
      let fail = 0
      for (let i = 0; i < list.length; i++) {
        const res = await dispatch('deleteEduContent', {
          uid: list[i],
          silent: true
        })
        if (res && res.code === 200) ok++
        else fail++
      }
      commit('selectionSet', { key: 'eduContent', value: [] }, { root: true })
      await dispatch('getEduContent', true)
      if (fail && !ok) {
        return { code: 400, msg: '批量删除失败' }
      }
      if (fail) {
        return {
          code: 200,
          msg: '已删除 ' + ok + ' 条，失败 ' + fail + ' 条'
        }
      }
      return { code: 200, msg: '已批量删除 ' + ok + ' 条教育内容' }
    },

    async getEduContent({ dispatch }, params) {
      const orgUid = await dispatch('eduOrgUid')
      // 列表页必须强制拉取：导航切换时 currentStep 可能尚未切到 eduContentList，
      // 若依赖 step 判断 sync，会被字典缓存跳过，表现为进页空白、点查询才有数据
      const sync = params !== false
      await dispatch(
        'dictionaryRequest',
        {
          key: 'eduContent',
          label: 'eduContent',
          value: 'uid',
          url: '/organize/dictionary/edubrief',
          data: orgUid ? { orgUid: orgUid } : {},
          sync: sync
        },
        { root: true }
      )
    },

    async editEduContent({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/dictionary/edubrief',
          data: Object.assign({}, data, orgUid ? { orgUid } : {}),
          msg: '编辑教育内容成功'
        },
        { root: true }
      )
      return res
    },

    async importEduContent({ dispatch }, payload) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/dictionary/edubrief/import',
          data: Object.assign({}, payload, orgUid ? { orgUid } : { orgUid: payload && payload.orgUid }),
          msg: true,
          timeout: 120000
        },
        { root: true }
      )
      return res
    },

    async syncEduContent({ dispatch }, mode) {
      const orgUid = await dispatch('eduOrgUid')
      if (!orgUid) {
        return { code: 500, msg: '系统默认字段不需要同步' }
      }
      const action = mode || 'fill'
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/organize/dictionary/edubrief/sync?orgUid=' +
            encodeURIComponent(orgUid) +
            '&mode=' +
            encodeURIComponent(action),
          data: {},
          msg: true,
          timeout: 120000
        },
        { root: true }
      )
      return res
    },

    fieldMenuScope({ rootGetters }) {
      return rootGetters['user/orgName'] === '甘肃大鹏鸟科技有限公司'
        ? 'super'
        : 'org'
    },

    async getSysFieldMenu({ dispatch, rootState }) {
      var sync = true
      if (rootState.currentStep.step !== 'fieldMenuList') {
        sync = true
      }
      await dispatch(
        'dictionaryRequest',
        {
          key: 'fieldMenu',
          label: 'fieldName',
          value: 'fieldCode',
          url: '/organize/dictionary/sysfieldmenu',
          data: { scope: await dispatch('fieldMenuScope') },
          sync: sync
        },
        { root: true }
      )
    },

    async editSysFieldMenu({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/dictionary/sysfieldmenu',
          data: data,
          msg: '保存成功'
        },
        { root: true }
      )
      return res
    },

    async getOrgDict({ dispatch, commit, rootState }, payload) {
      const dictCode =
        typeof payload === 'string' ? payload : payload && payload.dictCode
      if (!dictCode) return
      const orgUid = await dispatch('eduOrgUid')
      const label = dictCode === 'standardRates' ? 'type' : 'name'
      await dispatch(
        'dictionaryRequest',
        {
          key: dictCode,
          label: label,
          value: 'uid',
          url: '/organize/dictionary/orgdict',
          data: Object.assign({ dictCode: dictCode }, orgUid ? { orgUid: orgUid } : {}),
          sync: true
        },
        { root: true }
      )
      commit(
        'orgFieldsSet',
        {
          key: dictCode,
          value: rootState.dictionarys[dictCode] || []
        },
        { root: true }
      )
    },

    async getStandardRates({ dispatch }) {
      await dispatch('getOrgDict', 'standardRates')
    },

    async getEvaluationModule({ dispatch }) {
      await dispatch('getOrgDict', 'evaluationModule')
    },

    async addOrgDict({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const payload = Object.assign({}, data, orgUid ? { orgUid } : { orgUid: data && data.orgUid })
      if (payload.dictCode === 'standardRates') {
        payload.itemKey = payload.type
        payload.itemName = payload.type
      }
      if (payload.dictCode === 'evaluationModule') {
        payload.itemKey = payload.module
        payload.itemName = payload.name
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/dictionary/orgdict',
          data: payload,
          msg: '添加成功'
        },
        { root: true }
      )
      return res
    },

    async editOrgDict({ dispatch }, data) {
      const orgUid = await dispatch('eduOrgUid')
      const payload = Object.assign({}, data, orgUid ? { orgUid } : {})
      if (payload.dictCode === 'standardRates') {
        payload.itemKey = payload.type
        payload.itemName = payload.type
      }
      if (payload.dictCode === 'evaluationModule') {
        payload.itemKey = payload.module
        payload.itemName = payload.name
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/dictionary/orgdict',
          data: payload,
          msg: '编辑成功'
        },
        { root: true }
      )
      return res
    },

    async deleteOrgDict({ dispatch }, uid) {
      const orgUid = await dispatch('eduOrgUid')
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/dictionary/orgdict',
          data: orgUid ? { uid: uid, orgUid: orgUid } : { uid: uid },
          msg: '删除成功'
        },
        { root: true }
      )
      return res
    },

    async syncOrgDict({ dispatch }, payload) {
      const orgUid = await dispatch('eduOrgUid')
      if (!orgUid) {
        return { code: 500, msg: '系统默认字段不需要同步' }
      }
      const dictCode = payload && payload.dictCode ? payload.dictCode : payload
      const action = (payload && payload.mode) || 'fill'
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/organize/dictionary/orgdict/sync?orgUid=' +
            encodeURIComponent(orgUid) +
            '&dictCode=' +
            encodeURIComponent(dictCode || '') +
            '&mode=' +
            encodeURIComponent(action),
          data: {},
          msg: true,
          timeout: 120000
        },
        { root: true }
      )
      return res
    }
  }
}
